import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import DowntimeService from '../services/Downtime';

export const getDowntimeSubscribers = createAsyncThunk(
	'downtime/getSubscribers',
	async (_, { rejectWithValue }) => {
		try {
			const result = await DowntimeService.getSubscribers();
			return result.data.map((item) => ({
				...item,
				key: item.user_id,
			}));
		} catch (error) {
			return rejectWithValue(error);
		}
	},
);

export const notifyAllSubscribers = createAsyncThunk(
	'downtime/notifyAll',
	async (message, { dispatch, rejectWithValue }) => {
		try {
			const result = await DowntimeService.notifyAll(message);
			dispatch(getDowntimeSubscribers());
			return result;
		} catch (error) {
			return rejectWithValue(error);
		}
	},
);

export const downtimeSlice = createSlice({
	name: 'downtime',
	initialState: {
		subscribers: [],
		loading: false,
		notifyLoading: false,
		error: null,
	},
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(getDowntimeSubscribers.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(getDowntimeSubscribers.fulfilled, (state, action) => {
				state.loading = false;
				state.subscribers = action.payload;
			})
			.addCase(getDowntimeSubscribers.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message;
			})
			.addCase(notifyAllSubscribers.pending, (state) => {
				state.notifyLoading = true;
				state.error = null;
			})
			.addCase(notifyAllSubscribers.fulfilled, (state) => {
				state.notifyLoading = false;
			})
			.addCase(notifyAllSubscribers.rejected, (state, action) => {
				state.notifyLoading = false;
				state.error = action.error.message;
			});
	},
});

export default downtimeSlice.reducer;

export const selectDowntimeSubscribers = (state) =>
	state.downtime.subscribers || [];
